import { rest } from 'msw';
import day from 'utils/day';

import { API_ROOT } from 'configs/env-vars';
import { createAllFood, loggedFoodData, mockFood, mockNutrients, editedFood, foodLogs, loggedRecipeData } from '../mockData/food-logs-data';
import { loggingFood, pastaNutrients, brandedFoodHalfNutrients, brandedFoodRanchNutrients } from '../mockData/patient-recipes-data';

const FoodLogApi = [
  rest.get(`${API_ROOT}food-logs`, (req, res, ctx) => {
    const type = req.url.searchParams.get('type[]');
    const date = req.url.searchParams.get('date');
    const isRecent = req.url.searchParams.get('isRecent');
    const todayDate = day();
    if (date === todayDate.format('YYYY-MM-DD') && type === null) {
      return res(ctx.json(createAllFood));
    }
    if (type === 'Breakfast') {
      return res(ctx.json({ data: loggedFoodData }));
    }
    if (isRecent === 'true') {
      return res(ctx.json(loggedFoodData));
    }
    return res(
      ctx.json({
        migratedAt: false,
        graphData: {},
        oneDayGraph: {},
        data: [],
      }),
    );
  }),
  rest.get(`${API_ROOT}nutritionix/search`, (req, res, ctx) => {
    const query = req.url.searchParams.get('query');
    if (query === 'bacon') {
      return res(ctx.json(mockFood));
    }
    if (query === 'pasta') {
      return res(ctx.json([loggingFood[0]]));
    }
    if (query === 'half and half') {
      return res(ctx.json([loggingFood[1]]));
    }
    if (query === 'Ranch Snack Mix') {
      return res(ctx.json([loggingFood[2]]));
    }
    return res(ctx.json([]));
  }),
  rest.get(`${API_ROOT}nutritionix/nutrients`, (req, res, ctx) => {
    const query = req.url.searchParams.get('query');
    if (query === 'bacon 3 slices') {
      return res(ctx.json(mockNutrients));
    }
    if (query === 'pasta 1 cup spaghetti not packed') {
      return res(ctx.json(pastaNutrients));
    }
    if (query === 'Half and Half 2 tbsp') {
      return res(ctx.json(brandedFoodHalfNutrients));
    }
    if (query === 'Ranch Snack Mix 0.25 cup') {
      return res(ctx.json(brandedFoodRanchNutrients));
    }
    return res(ctx.json({}));
  }),
  rest.post(`${API_ROOT}food-logs/`, (req, res, ctx) => res(ctx.json(foodLogs))),
  rest.put(`${API_ROOT}food-logs/1478`, (req, res, ctx) => res(ctx.json(editedFood))),
  rest.get(`${API_ROOT}food-logs/5409`, (req, res, ctx) => res(ctx.json(loggedRecipeData[0]))),
  rest.delete(`${API_ROOT}food-logs/1478`, (req, res, ctx) => res(ctx.json(editedFood))),
];

export default FoodLogApi;
